import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/stores/user'
import Cookies from 'js-cookie';

import LoginPage from '../components/LoginPage.vue';
import LoginPage2 from '../components/LoginPage2.vue';
import RegisterPage from '../components/RegisterPage.vue';
import DashboardHomePage from '../components/dashboard/HomePage.vue';
import InitiatorHomePage from '@/components/dashboard/InitiatorHomePage.vue';
import ExecutiveDashboardPage from '@/components/dashboard/payment/executive/ExecutiveDashboardPage.vue';
import CreateUserPage from '../components/dashboard/user_functions/CreateUserPage.vue';
import CreateMdaPage from '@/components/dashboard/mda/CreateMdaPage.vue'
import EditMdaPage from '@/components/dashboard/mda/EditMdaPage.vue'
import ViewMdaPage from '@/components/dashboard/mda/ViewMdaPage.vue'
import ForgotPasswordPage from '@/components/ForgotPasswordPage.vue';
import EditBudgetPage from '@/components/dashboard/budget/EditBudgetPage.vue'
import UploadBudgetPage from '@/components/dashboard/budget/UploadBudgetPage.vue'
import ViewBudgetPage from '@/components/dashboard/budget/ViewBudgetPage.vue'
import ViewBudgetYearPage from '@/components/dashboard/budget/ViewBudgetYearPage.vue'
import ViewBudgetsPage from '@/components/dashboard/budget/ViewBudgetsPage.vue'
import BudgetApprovalPage from '@/components/dashboard/budget/BudgetApprovalPage.vue'
import BudgetDashboardPage from '@/components/dashboard/budget/dashboard/BudgetDashboardPage.vue';
import CreateEconomicLineItemPage from '@/components/dashboard/budget/CreateEconomicLineItemPage.vue'
import ViewEliBudgetPage from '@/components/dashboard/budget/ViewEliBudgetPage.vue'
import EditEliBudgetPage from '@/components/dashboard/budget/EditEliBudgetPage.vue'
import CreateRolePage from '../components/dashboard/user_functions/CreateRolePage.vue';
import CreateSectorPage from '@/components/dashboard/mda/CreateSectorPage.vue'
import CreateSubSectorPage from '../components/dashboard/mda/CreateSubSectorPage.vue';
import CreateApprovalAuthorityPage from '../components/dashboard/appraisal/CreateApprovalAuthorityPage.vue';
import AssignApprovalAuthorityPage from '@/components/dashboard/appraisal/AssignApprovalAuthorityPage.vue'
import CreateOccupierPage from '../components/dashboard/appraisal/CreateOccupierPage.vue';
import SearchLineItemPage from '../components/dashboard/budget/SearchLineItemPage.vue';
import GenerateAppraisalPage from '../components/dashboard/appraisal/GenerateAppraisalPage.vue';
import UpdateAppraisalPage from '../components/dashboard/appraisal/UpdateAppraisalPage.vue';
import ViewLineItemPage from '../components/dashboard/budget/ViewLineItemPage.vue';
import ViewRolesPage from '@/components/dashboard/reports/ViewRolesPage.vue';
import ViewUsersPage from '@/components/dashboard/reports/ViewUsersPage.vue';
import ViewApprovalAuthoritiesPage from '@/components/dashboard/reports/ViewApprovalAuthoritiesPage.vue';
import ViewSectorsPage from '@/components/dashboard/reports/ViewSectorsPage.vue';
import ViewSubSectorsPage from '@/components/dashboard/reports/ViewSubSectorsPage.vue';
import ViewAppraisalsPage from '../components/dashboard/appraisal/ViewAppraisalsPage.vue';
import ViewMdasPage from '@/components/dashboard/reports/ViewMdasPage.vue';
import ViewAppraisalPage from '../components/dashboard/appraisal/ViewAppraisalPage.vue';
import ViewOccupiersPage from '@/components/dashboard/reports/ViewOccupiersPage.vue';
import UpdateGroupMemberAppraisalPage from '../components/dashboard/appraisal/updateAppraisal/group-member/UpdateAppraisalPage.vue';
import UpdateGroupAppraisalPage from '../components/dashboard/appraisal/updateAppraisal/group-head/UpdateAppraisalPage.vue';
import UpdateDOBAppraisalPage from '../components/dashboard/appraisal/updateAppraisal/dob/UpdateAppraisalPage.vue';
import UpdatePSAppraisalPage from '../components/dashboard/appraisal/updateAppraisal/ps/UpdateAppraisalPage.vue';
import UpdateCommissionerAppraisalPage from '../components/dashboard/appraisal/updateAppraisal/commissioner/UpdateAppraisalPage.vue';
import ViewPendingNotificationsPage from '../components/dashboard/notification/ViewPendingNotificationsPage.vue';
import ImportManualAppraisalsPage from '../components/dashboard/appraisal/ImportManualAppraisalsPage.vue';
import UpdateApprovalAuthorityPage from '@/components/dashboard/appraisal/UpdateApprovalAuthorityPage.vue';
import ViewManualAppraisalPage from '../components/dashboard/appraisal/ViewManualAppraisalPage.vue';
import ViewManualAppraisalsPage from '../components/dashboard/appraisal/ViewManualAppraisalsPage.vue';
import UpdateManualAppraisalPage from '../components/dashboard/appraisal/UpdateManualAppraisalPage.vue';
import ProfilePage from '@/components/dashboard/ProfilePage.vue';
import EditRolePage from '@/components/dashboard/user_functions/EditRolePage.vue';
import EditUserPage from '@/components/dashboard/user_functions/EditUserPage.vue';
import CreateMemoPage from '@/components/dashboard/appraisal/CreateMemoPage.vue';
import ViewMemosPage from '../components/dashboard/appraisal/ViewMemosPage.vue';
import ViewAdminMemoPage from '../components/dashboard/appraisal/ViewAdminMemoPage.vue';
import ViewMemoPage from '../components/dashboard/appraisal/ViewMemoPage.vue';
import ApproveMemoUpdatePage from '../components/dashboard/appraisal/ApproveMemoUpdatePage.vue';
import UpdateMemoPage from '@/components/dashboard/appraisal/UpdateMemoPage.vue';
import ViewDailySummaryPage from '@/components/dashboard/reports/ViewDailySummaryPage.vue';
import ViewFileRegisterPage from '@/components/dashboard/reports/ViewFileRegisterPage.vue';
import ViewWarrantsPage from '@/components/dashboard/warrant/ViewWarrantsPage.vue';
import ViewWarrantPage from '@/components/dashboard/warrant/ViewWarrantPage.vue';
import ViewVoidedWarrantsPage from '@/components/dashboard/warrant/ViewVoidedWarrantsPage.vue';
// import PVGenerationNoWarrantPage from '@/components/dashboard/payment/PVGenerationNoWarrantPage.vue';
// import GroupHeadInitiateAppraisalPage from '@/components/dashboard/appraisal/initiateAppraisal/group-head/initiateAppraisalPage';
//addview waarants page, generatepayment voucher
import ViewGeneratePVWithWarrantPage from '@/components/dashboard/payment/ViewGeneratePVWithWarrantPage.vue';
import ViewGeneratePVWithoutWarrantPage from '@/components/dashboard/payment/ViewGeneratePVWithoutWarrantPage.vue';
import ViewGeneratePVWithWarrantTempPage from '@/components/dashboard/payment/ViewGeneratePVWithWarrantTempPage.vue';
import PVApprovalPage from '@/components/dashboard/payment/PVApprovalPage.vue';
import ViewConsultancyPage from '@/components/dashboard/payment/ViewConsultancyPage.vue';
import RegisterConsultantPage from '@/components/dashboard/payment/RegisterConsultantPage.vue';
import ViewPaymentVouchersPage from '@/components/dashboard/payment/ViewPaymentVouchersPage.vue';
import ViewUnlinkedPaymentVouchersPage from '@/components/dashboard/payment/ViewUnlinkedPaymentVouchersPage.vue';
import CreatePVMemoPage from '@/components/dashboard/pv_memo/CreatePVMemoPage.vue';
import ViewPVMemoPage from '@/components/dashboard/pv_memo/ViewPVMemoPage.vue';
import ViewPVMemosPage from '@/components/dashboard/pv_memo/ViewPVMemosPage.vue';
import ViewPaymentVoucherPage from '@/components/dashboard/payment/ViewPaymentVoucherPage.vue';
import ViewLinkPaymentVoucherPage from '@/components/dashboard/payment/ViewLinkPaymentVoucherPage.vue';
import CashbookPage from '@/components/dashboard/cashbook/CashbookPage.vue';
import ViewCashbookEntryPage from '@/components/dashboard/cashbook/ViewCashbookEntryPage.vue';
import CreateMemoFromPVPage from '@/components/dashboard/pv_memo/CreateMemoFromPVPage.vue';
import ViewSpecialApprovalsPage from '@/components/dashboard/appraisal/ViewSpecialApprovalsPage.vue';
import UpdateSpecialApprovalPage from '@/components/dashboard/appraisal/UpdateSpecialApprovalPage.vue';
import CreateSpecialApprovalTypePage from '@/components/dashboard/appraisal/approval/CreateSpecialApprovalType.vue';
import CreateSpecialApprovalPage from '@/components/dashboard/appraisal/approval/CreateSpecialApproval.vue';
import ViewSpecialApprovalTypePage from '@/components/dashboard/appraisal/approval/ViewSpecialApprovalType.vue';
import ViewSpecialApprovalTypesPage from '@/components/dashboard/appraisal/approval/ViewSpecialApprovalTypes.vue';
import ViewSpecialApprovalPage from '@/components/dashboard/appraisal/approval/ViewSpecialApproval.vue';
import ViewBanksPage from '@/components/dashboard/banks/ViewBanksPage.vue';
import ViewBankPage from '@/components/dashboard/banks/ViewBankPage.vue';
import EditBankPage from '@/components/dashboard/banks/EditBankPage.vue';
import CreateBankPage from '@/components/dashboard/banks/CreateBankPage.vue';
import CreateDelegationPage from '@/components/dashboard/delegate/CreateDelegationPage.vue';
import ViewDelegationLogPage from '@/components/dashboard/delegate/ViewDelegationLogPage.vue';
import ViewDelegationPage from '@/components/dashboard/delegate/ViewDelegationPage.vue';
import CreateDeductionPage from '@/components/dashboard/deduction/CreateDeductionPage.vue';
import EditDeductionPage from '@/components/dashboard/deduction/EditDeductionPage.vue';
import ViewDeductionPage from '@/components/dashboard/deduction/ViewDeductionPage.vue';
import ViewDeductionsPage from '@/components/dashboard/deduction/ViewDeductionsPage.vue';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  { path: '/login', name: 'Login', component: LoginPage2 },
  { path: '/register', name: 'Register', component: RegisterPage },

  // OLD
  { path: '/login2', name: 'Login2', component: LoginPage },

  {
    path: '/forgot-password',
    name: 'ForgotPasswordRequest',
    component: ForgotPasswordPage,
    meta: { requiresAuth: false }
  },

  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: { requiresAuth: true }
  },

  {
    path: '/dashboard',
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: DashboardHomePage,
        meta: { requiresAuth: true},
        beforeEnter: handleDashboardRedirect
      },
      {
        path: 'initiator',
        name: 'InitiatorDashboard',
        component: InitiatorHomePage,
        meta: { requiresAuth: true, bizClientId: [1001] } // Only for bizClient 1001
      },
      {
        path: 'executive',
        name: 'ExecutiveDashboard',
        component: ExecutiveDashboardPage,
        meta: { requiresAuth: true, bizClientId: [1001] } // Only for bizClient 1001
      },
      {
        path: 'create/role',
        name: 'CreateRole',
        component: CreateRolePage,
        meta: { requiresAuth: true, roles: [''] }
      },
      {
        path: 'create/user',
        name: 'CreateUser',
        component: CreateUserPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'create/mda',
        name: 'CreateMda',
        component: CreateMdaPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'edit/mda/:id',
        name: 'EditMda',
        component: EditMdaPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'view/mda/:id',
        name: 'ViewMda',
        component: ViewMdaPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'edit/budget',
        name: 'EditBudget',
        component: EditBudgetPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'upload/budget',
        name: 'UploadBudget',
        component: UploadBudgetPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'view/budget/:id',
        name: 'ViewBudget',
        component: ViewBudgetPage,
        meta: { requiresAuth: true, roles: ['', 'qssu', 'dirOfBudget', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'view/budget/year/:year',
        name: 'ViewBudgetYear',
        component: ViewBudgetYearPage,
        meta: { requiresAuth: true, roles: ['', 'qssu', 'dirOfBudget', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'view/budgets',
        name: 'ViewBudgets',
        component: ViewBudgetsPage,
        meta: { requiresAuth: true, roles: ['', 'qssu', 'dirOfBudget', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'budget/approval/:id',
        name: 'ApproveBudget',
        component: BudgetApprovalPage,
        meta: { requiresAuth: true, roles: ['', 'dirOfBudget', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'view/eli-budget/:id',
        name: 'ViewEliBudget',
        component: ViewEliBudgetPage,
        meta: { requiresAuth: true, roles: ['', 'qssu', 'dirOfBudget', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'edit/eli-budget/:id',
        name: 'EditEliBudget',
        component: EditEliBudgetPage,
        meta: { requiresAuth: true, roles: ['qssu'] }
      },
      {
        path: 'budget-performance',
        name: 'BudgetPerformanceDashboard',
        component: BudgetDashboardPage,
        meta: { requiresAuth: true, roles: ['', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'create/economiclineitem',
        name: 'CreateEconomicLineItem',
        component: CreateEconomicLineItemPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'create/sector',
        name: 'CreateSector',
        component: CreateSectorPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'create/subsector',
        name: 'CreateSubSector',
        component: CreateSubSectorPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'create/approvalauthority',
        name: 'CreateApprovalAuthority',
        component: CreateApprovalAuthorityPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'assign/approvalauthority',
        name: 'AssignApprovalAuthority',
        component: AssignApprovalAuthorityPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'create/occupier',
        name: 'CreateOccupier',
        component: CreateOccupierPage,
        meta: { requiresAuth: true, roles: ['', 'qssu'] }
      },
      {
        path: 'search/budget',
        name: 'SearchLineItem',
        component: SearchLineItemPage,
        meta: { requiresAuth: true}
      },{
        path: 'generate/memo',
        name: 'CreateMemo',
        component: CreateMemoPage,
        meta: { requiresAuth: true, roles: ['', 'registryOfficer', 'qssu'] }
      },
      {
        path: 'generate/appraisal/:id',
        name: 'GenerateAppraisal',
        component: GenerateAppraisalPage,
        meta: { requiresAuth: true, roles: ['', 'groupMember', 'groupHead'] }
      },
      // {
      //   path: 'initiate/group/appraisal/:id',
      //   name: 'GroupHeadInitiateAppraisal',
      //   component: GroupHeadInitiateAppraisalPage,
      //   meta: { requiresAuth: false, roles: ['groupHead', ''] }
      // },
      {
        path: 'create/appraisal/special-approval',
        name: 'CreateSpecialApproval',
        component: CreateSpecialApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/special-approvals',
        name: 'ViewSpecialApprovals',
        component: ViewSpecialApprovalsPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'special-approval/:id',
        name: 'UpdateSpecialApproval',
        component: UpdateSpecialApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/lineitem',
        name: 'ViewLineItem',
        component: ViewLineItemPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/roles',
        name: 'ViewRoles',
        component: ViewRolesPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/users',
        name: 'ViewUsers',
        component: ViewUsersPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/approvalauthorities',
        name: 'ViewApprovalAuthorities',
        component: ViewApprovalAuthoritiesPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/sectors',
        name: 'ViewSectors',
        component: ViewSectorsPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/subsectors',
        name: 'ViewSubSectors',
        component: ViewSubSectorsPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/memos',
        name: 'ViewMemos',
        component: ViewMemosPage,
        meta: { requiresAuth: false}
      },{
        path: 'view/admin/memos',
        name: 'ViewAdminMemos',
        component: ViewAdminMemoPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/memo/:id',
        name: 'ViewMemo',
        component: ViewMemoPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/memo/update/approval/:id',
        name: 'ApproveMemoUpdate',
        component: ApproveMemoUpdatePage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/appraisals',
        name: 'ViewAppraisals',
        component: ViewAppraisalsPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/manual/appraisals',
        name: 'ViewManualAppraisals',
        component: ViewManualAppraisalsPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/appraisal/:id',
        name: 'ViewAppraisal',
        component: ViewAppraisalPage, // fallback
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          const userStore = useUserStore()
          const userRole = userStore.profile?.role || {};

          if (userRole?.groupHead) {
            next({ name: 'UpdateGroupAppraisal', params: { id: to.params.id } })
          } else if (userRole?.dirOfBudget) {
            next({ name: 'UpdateDOBAppraisal', params: { id: to.params.id } })
          } else if (userRole?.perSec) {
            next({ name: 'UpdatePSAppraisal', params: { id: to.params.id } })
          } else if (userRole?.commOfBAndP) {
            next({ name: 'UpdateCommissionerAppraisal', params: { id: to.params.id } })
          } else if (userRole?.groupMember) {
            next({ name: 'UpdateGroupMemberAppraisal', params: { id: to.params.id } })
          } else {
            next() // fallback to default ViewAppraisalPage
          }
        }
      },
      {
        path: 'view/mdas',
        name: 'ViewMdas',
        component: ViewMdasPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/occupiers',
        name: 'ViewOccupiers',
        component: ViewOccupiersPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'update/appraisal/:id',
        name: 'UpdateAppraisal',
        component: UpdateAppraisalPage,
        meta: { requiresAuth: true, roles: ['groupMember',''] }
      },
      {
        path: 'update/group-member/appraisal/:id',
        name: 'UpdateGroupMemberAppraisal',
        component: UpdateGroupMemberAppraisalPage,
        meta: { requiresAuth: true, roles: ['groupMember', ''] }
      },
      {
        path: 'update/group/appraisal/:id',
        name: 'UpdateGroupAppraisal',
        component: UpdateGroupAppraisalPage,
        meta: { requiresAuth: true, roles: ['groupHead', ''] }
      },
      {
        path: 'update/dob/appraisal/:id',
        name: 'UpdateDOBAppraisal',
        component: UpdateDOBAppraisalPage,
        meta: { requiresAuth: true, roles: ['dirOfBudget', ''] }
      },
      {
        path: 'update/ps/appraisal/:id',
        name: 'UpdatePSAppraisal',
        component: UpdatePSAppraisalPage,
        meta: { requiresAuth: true, roles: ['perSec', ''] }
      },
      {
        path: 'update/commissioner/appraisal/:id',
        name: 'UpdateCommissionerAppraisal',
        component: UpdateCommissionerAppraisalPage,
        meta: { requiresAuth: true, roles: ['commOfBAndP', ''] }
      },
      {
        path: 'view/pending/notifications',
        name: 'ViewPendingNotifications',
        component: ViewPendingNotificationsPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'view/import/appraisal',
        name: 'ImportManualAppraisals',
        component: ImportManualAppraisalsPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'update/approvalauthority/:id',
        name: 'UpdateApprovalAuthority',
        component: UpdateApprovalAuthorityPage,
        meta: { requiresAuth: true, roles: ['qssu', ''] }
      },{
        path: 'update/memo/:id',
        name: 'UpdateMemo',
        component: UpdateMemoPage,
        meta: { requiresAuth: true, roles: ['registryOfficer',''] }
      },
      {
        path: 'view/manual/appraisal/:id',
        name: 'ViewManualAppraisal',
        component: ViewManualAppraisalPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'update/manual/appraisal/:id',
        name: 'UpdateManualAppraisal',
        component: UpdateManualAppraisalPage,
        meta: { requiresAuth: true}
      },
      {
        path: 'update/role/:id',
        name: 'EditRole',
        component: EditRolePage,
        meta: { requiresAuth: true, roles: [''] }
      },
      {
        path: 'update/user/:id',
        name: 'EditUser',
        component: EditUserPage,
        meta: { requiresAuth: true, roles: [''] }
      },
      {
        path: 'view/summary/daily',
        name: 'ViewDailySummary',
        component: ViewDailySummaryPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/register/file',
        name: 'ViewFileRegister',
        component: ViewFileRegisterPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/warrants',
        name: 'ViewWarrants',
        component: ViewWarrantsPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/warrant/:warrantId',
        name: 'ViewWarrant',
        component: ViewWarrantPage,
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/warrants/voided',
        name: 'ViewVoidedWarrants',
        component: ViewVoidedWarrantsPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/generate/pv-with-warrant/:warrantId',
        name: 'ViewGeneratePVWithWarrant',
        component: ViewGeneratePVWithWarrantPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/generate/pv-without-warrant/:memoId?',
        name: 'ViewGeneratePVWithoutWarrant',
        component: ViewGeneratePVWithoutWarrantPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/generate/pv-with-warrant-temp/:warrantId',
        name: 'ViewGeneratePVWithWarrantTemp',
        component: ViewGeneratePVWithWarrantTempPage,
        meta: { requiresAuth: true }
      },
      // {
      //   path: 'payment/generate/no-warrant',
      //   name: 'GeneratePVNoWarrant',
      //   component: PVGenerationNoWarrantPage,
      //   meta: { requiresAuth: false }
      // },
      {
        path: 'payment/pv-approval/:id?',
        name: 'ApprovePaymentVoucher',
        component: PVApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'payment/view/consultants',
        name: 'ViewConsultants',
        component: ViewConsultancyPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'payment/register/consultant',
        name: 'RegisterConsultant',
        component: RegisterConsultantPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/payment-vouchers',
        name: 'ViewPaymentVouchers',
        component: ViewPaymentVouchersPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/unlinked/payment-vouchers',
        name: 'ViewUnlinkedPaymentVouchers',
        component: ViewUnlinkedPaymentVouchersPage,
        meta: { requiresAuth: true }
      },{
        path: 'generate/pv-memo',
        name: 'CreatePVMemo',
        component: CreatePVMemoPage,
        meta: { requiresAuth: true, roles: ['', 'initiator'] }
      },{
        path: 'view/pv-memos',
        name: 'ViewPVMemos',
        component: ViewPVMemosPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/pv-memo/:id',
        name: 'ViewPVMemo',
        component: ViewPVMemoPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/payment-voucher/:id?',
        name: 'ViewPaymentVoucher',
        component: ViewPaymentVoucherPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/link/payment-voucher/:id?',
        name: 'ViewLinkPaymentVoucher',
        component: ViewLinkPaymentVoucherPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/cashbook',
        name: 'CashBook',
        component: CashbookPage,
        meta: { requiresAuth: true}
      },{
        path: 'view/cashbook-entry/:id?',
        name: 'CashBookEntry',
        component: ViewCashbookEntryPage,
        meta: { requiresAuth: true}
      },{
        path: 'generate/memo-from-pv',
        name: 'CreateMemoFromPV',
        component: CreateMemoFromPVPage,
        meta: { requiresAuth: true, roles: ['', 'initiator'] }
      },
      {
        path: 'create/special-approval-type',
        name: 'CreateSpecialApprovalType',
        component: CreateSpecialApprovalTypePage,
        meta: { requiresAuth: false }
      },
      {
        path: 'view/special-approval-types',
        name: 'ViewSpecialApprovalTypes',
        component: ViewSpecialApprovalTypesPage,
        meta: { requiresAuth: false }
      },
      {
        path: 'view/special-approval-type/:id',
        name: 'ViewSpecialApprovalType',
        component: ViewSpecialApprovalTypePage,
        meta: { requiresAuth: false }
      },
      {
        path: 'view/special-approval/:id',
        name: 'ViewSpecialApproval',
        component: ViewSpecialApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'create/bank',
        name: 'CreateBank',
        component: CreateBankPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/banks',
        name: 'ViewBanks',
        component: ViewBanksPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/bank/:id',
        name: 'ViewBank',
        component: ViewBankPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'edit/bank/:id',
        name: 'EditBank',
        component: EditBankPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'create/delegation',
        name: 'CreateDelegation',
        component: CreateDelegationPage,
        meta: { requiresAuth: true, roles: ['', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'view/delegations',
        name: 'ViewDelegationLog',
        component: ViewDelegationLogPage,
        meta: { requiresAuth: true, roles: ['', 'perSec', 'commOfBAndP'] }
      },
      {
        path: 'view/delegation',
        name: 'ViewDelegation',
        component: ViewDelegationPage,
        meta: { requiresAuth: true, roles: ['', 'perSec', 'commOfBAndP'] }
      },{
        path: 'create/deduction',
        name: 'CreateDeduction',
        component: CreateDeductionPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/deductions',
        name: 'ViewDeductions',
        component: ViewDeductionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'view/deduction/:id',
        name: 'ViewDeduction',
        component: ViewDeductionPage,
        meta: { requiresAuth: true }
      },
      {
        path: 'edit/deduction/:id',
        name: 'EditDeduction',
        component: EditDeductionPage,
        meta: { requiresAuth: true }
      },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

function isTokenValid(token) {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    const now = Math.floor(Date.now() / 1000);
    return exp > now;
  } catch (e) {
    return false;
  }
}


// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   const token = Cookies.get('auth_token');
//   const userStore = useUserStore();

//   if (requiresAuth && !isTokenValid(token)) {
//     Cookies.remove('auth_token');
//     return next({ name: 'Login' });
//   }

//   const routeRoles = to.meta.roles; // e.g. ['groupHead', 'qssu']
//   const profile = userStore.profile?.role || {};

//   if (routeRoles && routeRoles.length > 0) {
//     // allow if at least one required role property is false in profile
//     const hasAccess = routeRoles.some(role => profile?.[role] === false);

//     if (!hasAccess) {
//       return next({ name: 'Dashboard' }); // not authorized
//     }
//   }

//   next();


// });

const allRoles = [
  'qssu',
  'dirOfBudget',
  'perSec',
  'commOfBAndP',
  'registryOfficer',
  'groupHead',
  'groupMember',
  'initiator',
];

// Dashboard redirect handler
async function handleDashboardRedirect(to, from, next) {
  const userStore = useUserStore()

  // Ensure profile is loaded
  if (!userStore.profile || !userStore.profile?.role) {
    const token = Cookies.get('auth_token')
    if (token) {
      try {
        await userStore.fetchProfile()
      } catch (e) {
        return next({ name: 'Login' })
      }
    }
  }

  const bizClientId = userStore.bizClientId || 1000
  if (bizClientId === 1001) {
    next({ name: 'InitiatorDashboard' })
  } else {
    next()
  }
}

// BizClient access control
// function checkBizClientAccess(requiredBizClientId, userBizClientId, profileRoles = {}) {
//   if (!requiredBizClientId) return true;

//   // Check bizClientId match
//   if (userBizClientId !== requiredBizClientId) return false;

//   // TODO: Add additional role checks per bizClient if needed
//   // Example: if (requiredBizClientId === 1001 && !profileRoles.somePermission) return false;

//   return true;
// }

function checkRouteAccess(routeRoles, profileRoles) {
  if (!routeRoles || routeRoles.length === 0) return true;

  const profile = profileRoles || {};

  // If '' is included in allowed roles
  if (routeRoles.includes('')) {
    const otherRoles = routeRoles.filter(role => role !== '');

    // Explicitly listed roles are allowed
    if (otherRoles.some(role => profile?.[role])) return true;

    // Free users (roles not in predefined allRoles) get full access
    const isFreeUser = Object.keys(profile).every(
      r => !allRoles.includes(r) || profile[r] === false
    );
    if (isFreeUser) return true;

    // Predefined roles not explicitly listed are denied
    return false;
  }

  // Normal check: allow if any route role matches
  return routeRoles.some(role => profile?.[role]);
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const token = Cookies.get('auth_token');
  const userStore = useUserStore();

  if (token && (!userStore.profile || !userStore.profile?.role)) {
    try {
      await userStore.fetchProfile();
    } catch (e) {
      Cookies.remove('auth_token');
      return next({ name: 'Login' });
    }
  }

  const profileRoles = userStore.profile?.role || {};
  const userBizClientId = userStore.bizClientId;

  // Redirect to login if auth required but token invalid
  if (requiresAuth && !isTokenValid(token)) {
    Cookies.remove('auth_token');
    return next({ name: 'Login' });
  }

  // Check bizClientId restrictions (skip if route has beforeEnter that handles it)
  const routeBizClientIds = to.meta.bizClientId; // array of allowed bizClientIds
  const hasCustomBeforeEnter = to.beforeEnter !== undefined;

  if (routeBizClientIds && Array.isArray(routeBizClientIds) && !hasCustomBeforeEnter) {
    // If bizClientId doesn't exist, default to normal Dashboard (1000)
    const bizClient = userBizClientId || 1000;
    if (!routeBizClientIds.includes(bizClient)) {
      // Redirect to appropriate dashboard based on bizClientId
      if (bizClient === 1001) {
        return next({ name: 'InitiatorDashboard' });
      } else {
        return next({ name: 'Dashboard' });
      }
    }
  }

  // Check role-based access
  const routeRoles = to.meta.roles; // roles defined in route meta
  if (routeRoles && !checkRouteAccess(routeRoles, profileRoles)) {
    return next({ name: 'Dashboard' }); // not authorized
  }

  next();
});

export default router;
